module.exports = __webpack_public_path__ + "img/first-2.d7cc1149.webp";